import { ConfigType, ManipulateType } from "dayjs";

import dayjs from "@/common/utils/dayjs";
import pluralize from "@reflag/shared/utils/pluralize";

export const fullFormattedDateTime = (date: ConfigType) =>
  dayjs(date).format("LLLL");

export const compactFormattedDate = (date: ConfigType) =>
  dayjs(date).format("ddd, ll");

export const compactFormattedDateTime = (date: ConfigType) =>
  dayjs(date).format("ddd, ll, LT");

export const epochToShortDate = (epoch?: number | string) => {
  if (!epoch || typeof epoch === "string") return "";
  return dayjs.unix(epoch).format("MMM D");
};

export const epochToDate = (epoch?: number | string) => {
  if (!epoch || typeof epoch === "string") return "";
  return dayjs.unix(epoch).format("MMM D, LT");
};

export const epochIsSame = (
  epoch: number,
  unit?: ManipulateType | undefined,
) => {
  const shift = dayjs().utcOffset() >= 0 ? 1 : 0;
  return dayjs.unix(epoch).isSame(dayjs().add(shift, unit), unit);
};

export const humanizeWeeks = (value: number) => {
  const weeks = Math.trunc(value);
  const days = Math.floor((value % 1) * 7);
  const parts = [];
  if (weeks > 0) {
    parts.push(`${weeks} ${pluralize("week", weeks)}`);
  }
  if (days > 0) {
    parts.push(`${days} ${pluralize("day", days)}`);
  }
  return parts.join(", ");
};

export const relativeTimeBuckets = (
  value: string | null | undefined,
  asNumber = false,
): string | number => {
  if (!value) return asNumber ? 99 : "Never";
  const date = dayjs(value);
  const now = dayjs();
  if (date.isSame(now, "day")) {
    return asNumber ? 0 : "Today";
  } else if (date.isAfter(now.subtract(7, "day"))) {
    return asNumber ? 1 : "Past week";
  } else if (date.isAfter(now.subtract(1, "month"))) {
    return asNumber ? 2 : "Past month";
  } else if (date.isAfter(now.subtract(3, "month"))) {
    return asNumber ? 3 : "Past 3 months";
  } else {
    return asNumber ? 4 : "More than 3 months ago";
  }
};

export const relativeTimeBucketLabel = (value: number): string => {
  switch (value) {
    case 0:
      return "Today";
    case 1:
      return "Past week";
    case 2:
      return "Past month";
    case 3:
      return "Past 3 months";
    case 4:
      return "More than 3 months ago";
    default:
      return "Never";
  }
};
